import { z } from 'zod';

export const createArticleSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters'),
  description: z.string().min(1, 'Description is required'),
  content: z.string().min(1, 'Content is required'),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
  is_published: z.preprocess((val) => val === 'true' || val === true, z.boolean()).default(false),
});

export type CreateArticlePayload = z.infer<typeof createArticleSchema>;
